import { render, staticRenderFns } from "./TaskWorksItem.vue?vue&type=template&id=5d3e1464&scoped=true&"
import script from "./TaskWorksItem.vue?vue&type=script&lang=js&"
export * from "./TaskWorksItem.vue?vue&type=script&lang=js&"
import style0 from "./TaskWorksItem.vue?vue&type=style&index=0&id=5d3e1464&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3e1464",
  null
  
)

export default component.exports